import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  FetchProductsApi,
  FetchSponsorProducts,
  UpdateSponsorProducts,
} from "../../ApiCalls/AddProducts";
import { BASE_URL } from "../../constant/api";
import { toast, ToastContainer } from "react-toastify";

const SellerSponsorEdit = () => {
  const { sponsorId } = useParams();
  const [sponsor, setSponsor] = useState(null);
  const [title, setTitle] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [bannerFile, setBannerFile] = useState(null);
  const [fetchedProducts, setFetchedProducts] = useState([]);
  const [sponsoredProducts, setSponsoredProducts] = useState(null);
  const [updatedBannerFile, setUpdatedBannerFile] = useState(null);
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null);

  const fetchProducts = async () => {
    setLoading(true); // Set loading to true when fetching
    try {
      const products = await FetchProductsApi();
      setFetchedProducts(products.Data);
    } catch (error) {
      console.error("Error fetching products:", error);
      setError("Failed to fetch products.");
    } finally {
      setLoading(false); // Set loading to false when fetching is done
    }
  };

  useEffect(() => {
    const fetchSponser = async () => {
      setLoading(true); // Set loading to true when fetching sponsor
      try {
        const response = await FetchSponsorProducts(sponsorId);
        setSponsor(response.sponsored);
        setTitle(response.sponsored.title);
        setStartDate(response.sponsored.start_date);
        setEndDate(response.sponsored.end_date);
        setSponsoredProducts(response.products);
      } catch (error) {
        console.error("Error sponser fetching products:", error);
        setError("Failed to fetch sponsor details.");
      } finally {
        setLoading(false); // Set loading to false when sponsor fetching is done
      }
    };
    fetchSponser();
    fetchProducts();
  }, [sponsorId]);

  const addToSponsored = (product) => {
    if (!sponsoredProducts.some((p) => p.id === product.id)) {
      const updatedList = [...sponsoredProducts, product];
      setSponsoredProducts(updatedList);
      setFetchedProducts((prev) => prev.filter((p) => p.id !== product.id));
    }
  };

  const removeFromSponsored = (productId) => {
    const removedProduct = sponsoredProducts.find((p) => p.id === productId);
    if (!removedProduct) return;

    setSponsoredProducts(sponsoredProducts.filter((p) => p.id !== productId));

    // Ensure the product is not duplicated in fetchedProducts
    setFetchedProducts((prev) => {
      return prev.some((p) => p.id === removedProduct.id)
        ? prev
        : [...prev, removedProduct];
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Preview the selected banner
      const previewUrl = URL.createObjectURL(file);
      setSponsor({ ...sponsor, sponsored_banner: previewUrl });
      setUpdatedBannerFile(file);
    }
  };
  const handleUpdate = async () => {
    try {
     
      const formData = new FormData();
      formData.append("title", title);
      formData.append("start_date", startDate);
      formData.append("end_date", endDate);
      if (updatedBannerFile) {
        formData.append("sponsored_banner", updatedBannerFile);
      }

      // Convert sponsoredProducts into separate form fields
      sponsoredProducts.forEach((p, index) => {
        formData.append(`sponsored_products[${index}]product`, p.id.toString());
      });

      console.log("Formatted FormData:", formData);

      // Send the request
      const response = await UpdateSponsorProducts(sponsorId, formData);

      toast.success("Sponsor Updated successfully!");
    } catch (error) {
      console.error("Error updating sponsor:", error);
      toast.error("Error updating Sponsor!");
    }
  };

  

  return (
    <div className="container mx-auto px-4 py-6">
      <ToastContainer position="top-center" autoClose={3000} />
      <h2 className="mb-5 text-center text-2xl font-medium">
        Update New Sponsor
      </h2>
      {loading ? (
        <div className="text-center">Loading...</div> // Show loading message
      ) : sponsor ? (
        <div>
          <div className="mb-6 flex w-full gap-10">
            <div className="group relative h-44 w-1/2 overflow-hidden rounded-lg bg-slate-100 shadow-md">
              <input
                type="file"
                className="absolute inset-0 z-30 cursor-pointer opacity-0"
                onChange={handleFileChange} // Ensure this is wired correctly
              />
              {sponsor?.sponsored_banner || updatedBannerFile ? (
                <img
                  src={
                    updatedBannerFile
                      ? URL.createObjectURL(updatedBannerFile)
                      : `${BASE_URL}${sponsor.sponsored_banner}`
                  }
                  alt="Sponsor Banner"
                  className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
              ) : (
                <div className="flex h-full items-center justify-center bg-gray-200 font-medium text-gray-500">
                  No Banner Available
                </div>
              )}
            </div>

            <div className="flex flex-1 flex-col space-y-4">
              <div className="flex w-1/3 flex-col space-y-2">
                <label className="text-base font-medium text-brand-primary">
                  Title
                </label>
                <input
                  type="text"
                  value={title}
                  onChange={(e) => {
                    setTitle(e.target.value);
                    setSponsor((prev) => ({ ...prev, title: e.target.value }));
                  }}
                  className="rounded-lg border border-black p-2"
                />
              </div>
              <div className="flex gap-4">
                <div className="flex flex-col space-y-2">
                  <label className="text-base font-medium text-brand-primary">
                    Start Date
                  </label>
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => {
                      setStartDate(e.target.value);
                      setSponsor((prev) => ({
                        ...prev,
                        start_date: e.target.value,
                      }));
                    }}
                    className="rounded-lg border border-black p-2"
                  />
                </div>
                <div className="flex flex-col space-y-2">
                  <label className="text-base font-medium text-brand-primary">
                    End Date
                  </label>

                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => {
                      setEndDate(e.target.value);
                      setSponsor((prev) => ({
                        ...prev,
                        end_date: e.target.value,
                      }));
                    }}
                    className="rounded-lg border border-black p-2"
                  />
                </div>
              </div>
              <div className="text-right">
                <button
                  className="rounded-lg bg-green-500 px-6 py-2 text-white hover:bg-green-600"
                  onClick={handleUpdate}
                >
                  Update Sponsor
                </button>
              </div>
            </div>
          </div>
          <div>
            <div className="grid grid-cols-[4rem,2fr,2.5fr,1.5fr,1.5fr,5fr] p-2 font-medium text-brand-button-green-bg">
              <div className="text-center">Item No</div>
              <div className="text-center">Product Code</div>
              <div className="text-center">Product Name</div>
              <div className="text-center">Stock</div>
              <div className="text-center">Price</div>
              <div className="text-center">Actions</div>
            </div>
            {sponsoredProducts.length === 0 ? (
              <div className="py-4 text-center text-gray-500">
                No products added yet
              </div>
            ) : (
              sponsoredProducts.map((product, index) => (
                <div
                  key={product.id}
                  className="grid grid-cols-[4rem,2fr,2.5fr,1.5fr,1.5fr,5fr] p-2 text-gray-700"
                >
                  <div className="text-center">{index + 1}</div>
                  <div className="text-center">{product.product_code}</div>
                  <div className="text-center">{product.name}</div>
                  <div className="text-center">{product.stock}</div>
                  <div className="text-center">{product.price}</div>
                  <div className="text-center">
                    <button
                      className="rounded-lg bg-red-500 px-4 py-2 text-white"
                      onClick={() => removeFromSponsored(product.id)}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
          <div className="border-t"></div>
          {fetchedProducts?.map((product, index) => {
            const isAlreadySponsored = sponsoredProducts.some(
              (sponsoredProducts) => sponsoredProducts.id === product.id,
            );

            return !isAlreadySponsored ? (
              <div
                key={product.id}
                className="grid grid-cols-[4rem,2fr,2.5fr,1.5fr,1.5fr,5fr] items-center p-2 text-gray-700"
              >
                <div className="text-center">{index + 1}</div>
                <div className="text-center">{product.product_code}</div>
                <div className="text-center">{product.name}</div>
                <div className="text-center">{product.stock}</div>
                <div className="text-center">{product.price}</div>
                <div className="text-center">
                  <button
                    className="rounded-lg bg-blue-500 px-4 py-2 text-white"
                    onClick={() => addToSponsored(product)}
                  >
                    Add to Sponsored
                  </button>
                </div>
              </div>
            ) : null;
          })}
        </div>
      ) : (
        <div className="text-center text-gray-600">
          <p>No sponsor details found.</p>
        </div>
      )}
    </div>
  );
};

export default SellerSponsorEdit;
